import React, { Component } from "react";

import {reduxForm} from 'redux-form';
import { connect } from 'react-redux';

import Grid from '@material-ui/core/Grid'
import { getHistoricDashboard } from "../../actions/repairAction";
import {Pie, PieChart, Cell, Tooltip} from 'recharts';

class RepairsDashboard extends Component {
    constructor(props){
        super(props);

        this.state={
            open : false,
            tableData:[],
            superUserCommunitySelected: undefined,
            superUserRepairsLoaddedForCommunity: undefined,
            maxAvgTime:0
        };
    }

    componentDidMount(){
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        this.props.getHistoricDashboard(localStorage.getItem('communityId'));
    }

    componentWillUnmount(){
        window.removeEventListener("resize", this.resize.bind(this));
    }

    resize() {
     this.setState({isMobile: window.innerWidth <= 960});
    }


    GetCommunityObjectForSupuerUserCombo(communityId){
        let communityObj = null;
        if(this.props.communityData){
            
            communityObj = this.props.communityData.find( item => item.communityId === communityId);
        }

        return  communityObj;
    };

    render() {
        //#region inner Components
        const RenderOpenRepairsDashboard = () =>{
           
            return (
                <Grid item container xs={12}>
                    <Grid item container  xs={12}>
                        <Grid item className="LtitleRepairsDashboard" xs={12}>Repair Requests</Grid>
                        {/* Total opened */}
                        <Grid item xs={5} style={{margin:'10px'}}>
                            <Grid item xs={12} className="LCurrenlyOpenBox">
                                <Grid container justifyContent='space-around' alignItems='center' >

                                    
                                <svg fill='#DB5B70' width='58px' height='58px' style={{opacity:'0.56'}} viewBox="0 0 576 512">                                   
                                    <path xmlns="http://www.w3.org/2000/svg" d="M507.42 114.49c-2.34-9.47-9.66-16.98-19.06-19.61-9.47-2.61-19.65 0-26.65 6.98l-63.87 63.87-44.25-7.36-7.38-44.24 63.87-63.87c6.94-6.92 9.62-17.09 7-26.54-2.62-9.47-10.19-16.83-19.75-19.2C345.6-8.31 291.95 6.54 254.14 44.3c-37.84 37.87-52.21 92.52-38.62 144.7L22.19 382.29c-29.59 29.63-29.59 77.83 0 107.45C36.54 504.09 55.63 512 75.94 512s39.37-7.91 53.71-22.26l193.14-193.11c52.03 13.73 106.8-.72 144.89-38.82 37.81-37.81 52.68-91.39 39.74-143.32zm-62.36 120.7c-31.87 31.81-78.43 42.63-121.77 28.23l-9.38-3.14-206.88 206.84c-16.62 16.62-45.59 16.62-62.21 0-17.12-17.14-17.12-45.06 0-62.21l207.01-206.98-3.09-9.34c-14.31-43.45-3.56-90.06 28.03-121.67C299.48 44.2 329.44 32 360.56 32c6.87 0 13.81.59 20.72 1.81l-69.31 69.35 13.81 83.02L408.84 200l69.3-69.35c6.72 38.25-5.34 76.79-33.08 104.54zM80 416c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16z"/>
                                </svg>
                        
                        
                                <Grid className="CurrenlyOpenNumber"  style={{color:'#DB5B70'}}> {this.props.totalOpen}</Grid>
                        
                                </Grid>
                                    <Grid item xs={12} className="LCurrenlyOpenText" style={{color:'#DB5B70'}}> Currently Open</Grid>
                                </Grid>
                        </Grid>

                        {/* Water damage risk */}
                        <Grid item xs={5} style={{margin:'10px'}}>
                            <Grid item xs={12} className="LCurrenlyOpenBox">
                                <Grid container justifyContent='space-around' alignItems='center'  >

                                <svg fill='#009EDD' width='58px' height='58px'  style={{opacity:'0.56'}} viewBox="0 0 576 512">                                   
                                    <path xmlns="http://www.w3.org/2000/svg"
                                     d="M252 193c-15.4 0-28 12.6-28 28v72c0 15.4 12.6 28 28 28h72c15.4 0 28-12.6 28-28v-72c0-15.4-12.6-28-28-28h-72zm68 96h-64v-64h64v64zm248.3 160c-29.5-1.5-57.7-11.6-78.2-28.3-5.9-4.8-14.3-4.8-20.2.1-43.7 35.9-127 36.3-171.8-.1-5.9-4.8-14.3-4.8-20.2.1-43.7 35.9-127 36.2-171.8-.1-5.9-4.8-14.3-4.7-20.2.1-20.2 16.6-48.4 26.7-78.2 28.2-4.3.2-7.7 3.6-7.7 7.9v16c0 4.5 3.8 8.3 8.3 8.1 32.3-1.5 63.3-11.4 87.8-27.9 53.8 36.1 139.2 35.8 192 0 53.7 36.1 139.2 35.8 192 0 24.6 16.5 55.6 26.4 87.6 27.9 4.5.2 8.3-3.6 8.3-8.1v-16c0-4.3-3.4-7.7-7.7-7.9zM45.9 252.4c2.1 2.6 5.9 3 8.5.9L96 219.8v165.4c10.9 0 21.6 3.8 30.2 10.7.5.4 1.2.7 1.8 1.1V194L284.1 68.1c2.2-1.8 5.3-1.8 7.5 0l156 125.9v203.3c.6-.4 1.3-.8 1.9-1.2 8.5-7 19.2-10.8 30.2-10.9V219.9l41.6 33.5c2.6 2.1 6.4 1.7 8.5-.9l12.6-15.6c2.1-2.6 1.6-6.4-.9-8.5l-61.8-49.7v-75.9c0-3.3-2.7-6-6-6h-20c-3.3 0-6 2.7-6 6v50.1L307.9 40.1c-11.7-9.5-28.5-9.5-40.2 0L34.2 228.4c-2.6 2.1-3 5.9-.9 8.4l12.6 15.6z"/>
                                </svg>
                             
                        
                                <Grid className="CurrenlyOpenNumber" style={{color:'#009EDD'}}> {this.props.waterDamage}</Grid>
                        
                                </Grid>
                                    <Grid item xs={12} className="LCurrenlyOpenText" style={{color:'#009EDD'}}>Water Damage Risk</Grid>
                                </Grid>
                        </Grid>

                         {/* Water damage risk */}
                         <Grid item xs={5} style={{margin:'10px'}}>
                            <Grid item xs={12} className="LCurrenlyOpenBox">
                                <Grid container justifyContent='space-around' alignItems='center'>
                        
                                <img 
                                    src='https://engage360.s3.amazonaws.com/Icons/Categories/thermometer-half.svg'
                                    alt='temperature' 
                                    className="CurrenlyOpenIcon logo-black"
                                />
                                <Grid className="LCurrenlyOpenNumber"> {this.props.residentDiscomfort}</Grid>
                        
                                </Grid>
                                    <Grid item xs={12} className="LCurrenlyOpenText">Resident Discomfort Risk</Grid>
                                </Grid>
                        </Grid>
                    
                    </Grid>
                </Grid>
            );
        }
        //#endregion

        const RenderClosedRepairsDashboard = () =>{

            const closeRepairs = this.props.dashboardClosedRepairs;
            

            return (
                <Grid item container xs={12} style={{paddingRight:'10px'}}>
                    <Grid item xs={12} className="LtitleRepairsDashboard">Average Time To Complete Request Per Repair Item (Last 30 Days)</Grid>
                    <Grid container className="LclosedRepairs">
                        {
                            (closeRepairs!==undefined)?
                            closeRepairs.map((item, index)=>{                          

                                let time= Math.round(item.avgDiff/60000); //minutes
                                let maxTime = this.props.maxAvgTime; //maxTime minutes
                                let unit='min';
                                
                                if(time>=60)//minutes
                                {
                                    unit='hrs';
                                    let hours=time/60;
                                    let MaxTimeHours=maxTime/60 //Max time in hours
                                    time=Math.round(hours);//hours  
                                    maxTime=Math.round(MaxTimeHours);

                                    if(hours>24) //more than a day
                                    {
                                        unit='days';
                                        let days=hours/24
                                        let maxTimeDays=MaxTimeHours/24; //Max time in days
                                        time=Math.round(days);
                                        maxTime=Math.round(maxTimeDays); 
                                    }                                                         
                                }
                                let PercentageWidth=(100/maxTime)*time;

                                let itemName = item._id.name;

                                if(itemName){
                                    itemName = itemName.charAt(0).toUpperCase()+ itemName.slice(1);
                                }

                                return(
                                    <Grid item  key={index} container xs={12} style={{padding:'10px', minHeight:'126px', backgroundColor:(index%2===0)?'#eeeeee':'#fafafa'}}>
                                        <Grid item container xs={2} alignItems='center' justifyContent='space-around' id='repairsPage_Item_ImageItem'>
                                            <img 
                                                src={item._id.iconUrl}
                                                alt={itemName} 
                                                className="ClosedRepairsIcon logo-black"
                                            />
                                            <Grid item xs={12} className="closedRepairsRowText txt_black">{itemName}</Grid>
                                        </Grid>
                                        <Grid container item xs={2} alignItems='center' justifyContent='center' id='repairsPage_Item_count'>
                                            <Grid item xs={12} className="closedRepairsNumberRequest txt_black">{item.count}</Grid> 
                                            <Grid item xs={12} className="closedRepairsRequest txt_black">Requests Completed</Grid>
                                        </Grid>
                                        <Grid item xs={7} style={{margin:'auto'}}>
                                            {
                                                item.avgDiff !==null?
                                                <>
                                                    <Grid item xs={12} id='repairsPage_Item_loader'>
                                                        <div style={{backgroundColor:'#009edd', borderRadius:'10px', height:'10px', maxWidth:'100%', width:(PercentageWidth>1? PercentageWidth+'%' : '1%')}}></div>                                                
                                                    </Grid> 
                                                    <Grid item xs={12} style={{fontSize:'14px',fontFamily:'Gotham-Book', marginTop:'10px',color:'black', marginLeft:(PercentageWidth>=90)?('90%'):(PercentageWidth + '%')}}> {time} {unit} </Grid>
                                                </>
                                                :
                                                <Grid item xs={12} style={{fontSize:'18px',fontFamily:'Gotham-Book', marginTop:'10px', color:'black'}}> No repairs were completed for this item. </Grid>

                                             
                                            }
                                        </Grid>
                                    </Grid>
                                )
                            })
                            :
                            <Grid item xs={12} style={{textAlign:'center', padding:'5px'}}>No data found</Grid>
                        }
                    </Grid>
                 
                </Grid>
            );

        }

        
        
        const renderCustomizedLabel = ({
          cx, cy, midAngle, innerRadius, outerRadius, percent, index, value
        }) => {

            const z= 1.5;
            const RADIAN = Math.PI / 180;
           const radius = innerRadius + (outerRadius - innerRadius) * z;
          const x = cx + radius * Math.cos(-midAngle * RADIAN);
          const y = cy + radius * Math.sin(-midAngle * RADIAN);
        
            return (
            <text x={x} y={y} fill="white" fontSize='15px' fontFamily='Gotham-Bold' textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
              {(value>3)?`${value.toFixed(0)}%`:''}
            </text>
          );
            
        };
        const CustomTooltip = ({ active, payload}) => {
            
            if (active) {
              return (
                  <p className="GraphicTooltip">{`${payload[0].name}: ${payload[0].value}%`}</p>
              );
            }
          
            return null;
          };

        const RenderHistoricalIssuesBreakdown=()=>{

            const generarLetra=()=>{
                var letras = ["a","b","c","d","e","f","0","1","2","3","4","5","6","7","8","9"];
                var numero = (Math.random()*15).toFixed(0);
                return letras[numero];
            }
                
            const colorHEX=()=>{
                var coolor = "";
                for(var i=0;i<6;i++){
                    coolor = coolor + generarLetra() ;
                }
                return "#" + coolor;
            }

            const COLORS = [
                '#349ce3','#8f44f4','#d35e70', '#5cd97b', '#dfd708',
                '#b0aeaf','#84d4f4','#549c64','#3e76e4','#a494b4',
                '#54478c','#2c699a','#f29e4c','#048ba8','#efea5a',
                '#0db39e','#16db93','#ffa69e','#1a4301','#49111c',
                '#007200','#008bf8','#d62828','#14213d','#3a0ca3',
                '#48bfe3','#43aa8b','#4d194d','#c9ada7','#370617'
            ];

            const historicalIssuesData=this.props.historicalIssues;
            const data=[];

            if(historicalIssuesData!==undefined){
                
                if(historicalIssuesData.length>30){

                    for (let i = 0; i < historicalIssuesData.length-30; i++) {
                        COLORS.push(colorHEX());
                    }

                }
                
                historicalIssuesData.forEach((item, index)=>{

                    let obj={

                        name:item._id.name,
                        value:Math.round(item.percentage),
                        color:COLORS[index]
                    }
                    data.push(obj);
                });

            }
            return(
                <Grid  container>
                   <Grid className="LtitleRepairsDashboard" item>Issues Breakdown (Last 30 Days)</Grid> 
                   <Grid container item xs={12} alignItems='center' justifyContent='center' direction='column' >
                       {
                            (data!==undefined)?

                            <Grid item container xs={12} alignItems='center' justifyContent='center' id='repairPage_HistoricalChart'>
                                <PieChart xs={12} width={500} height={300} item>
                                    <Pie
                                        data={data}
                                        cx='45%'
                                        cy='50%'
                                        startAngle={90}
                                        endAngle={-270}
                                        innerRadius={85}
                                        outerRadius={110}
                                        fill="#8884d8"
                                        paddingAngle={0}    
                                        label={renderCustomizedLabel}
                                        labelLine={false}
                                    >
                                        {
                                            data.map((item, index) => 
                                                <Cell key={`cell-${index}`} fill={COLORS[index]} stroke={COLORS[index]}/>
                                                
                                            )        
                                        }    
                                    </Pie>
                                    <Tooltip content={CustomTooltip} />
                                </PieChart>

                                {
                                    data.map((item, index)=>
                                        <Grid key={index} item container>
                                            <Grid container direction='row' alignItems='center' justifyContent='center' style={{marginBottom:'5px', color:'black'}}>
                                                <Grid item style={{borderRadius:'10px', height:'15px', width:'15px', backgroundColor:(item.color)}}></Grid>
                                                <Grid item  className="GraphicLabels" xs={4} id='repairPage_HistoricalChart_Name'>{item.name} </Grid>
                                                <Grid item  className="GraphicLabels" xs={2} id='repairPage_HistoricalChart_Value'>{item.value + '%'} </Grid>
                                            </Grid>                                           
                                        </Grid>
                                    )
                                }
                            </Grid>
                               
                            :
                            <Grid>No data found</Grid>
                       }
                   </Grid>
                </Grid>
            )   
        }

        return (     
            <Grid item container xs={12} justifyContent='space-between' alignItems='flex-start' style={{padding:'20px'}}>
                <Grid item container xs={12} lg={5} justifyContent='flex-start'>
                    <RenderOpenRepairsDashboard xs={12}/>
                    <RenderHistoricalIssuesBreakdown xs={12} />
                </Grid>
                <Grid item container xs={12} lg={7} justifyContent='space-around'>
                    <RenderClosedRepairsDashboard xs={12}/>
                </Grid>
            </Grid>
        )
    }
}

function mapStateToProps(state,dispatch) {

    const communityData = (state.communityReducer && state.communityReducer.communityData)? state.communityReducer.communityData.map(item =>({_id:item._id, name: item.communityName, communityId: item.communityId})) : [];
    const dashboardRepairData = (state.repairReducer && state.repairReducer.dashboardRepairData)? state.repairReducer.dashboardRepairData : [];
    const dashboardClosedRepairs= (state.repairReducer && state.repairReducer.dashboardRepairData  && state.repairReducer.dashboardRepairData.close)? state.repairReducer.dashboardRepairData.close.sort((a, b)=>{
        if(a.count===b.count){
            let x = a._id.name.toLowerCase();
            let y = b._id.name.toLowerCase();
            if (x < y) {return -1;}
            if (x > y) {return 1;}
        }

        return b.count - a.count;
      }) : [];
    const historicalIssues=dashboardRepairData.total;
    const waterDamage = dashboardRepairData?.waterDamage? dashboardRepairData.waterDamage : 0;
    const residentDiscomfort = dashboardRepairData?.residentDiscomfort? dashboardRepairData.residentDiscomfort : 0;
    const totalOpen = dashboardRepairData?.totalOpen? dashboardRepairData.totalOpen : 0 

    const arr =  dashboardClosedRepairs.map(i=>(i.avgDiff))    
    const maxAvgTime = Math.max(...arr)

    return {       
        tableData:  dashboardRepairData,
        communityData: communityData,
        dashboardClosedRepairs,
        historicalIssues:historicalIssues,
        waterDamage,
        residentDiscomfort,
        totalOpen,
        maxAvgTime: isNaN(maxAvgTime)? 0 : maxAvgTime/60000 //Max time to complete in minutes
    }
}


RepairsDashboard = reduxForm({
    form: 'RepairsDashboardForm',    
    enableReinitialize: true,
})(RepairsDashboard);

export default connect(mapStateToProps, {getHistoricDashboard})(RepairsDashboard);
